import { energyApi } from '../api'

const getAll = async () => {
  try {
    const response = await energyApi.getAll()
    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()
      const operators = responseBody.data.map(({ id, attributes: a }) => ({
        value: id,
        label: a.name,
      }))
      return { success: true, payload: { operators } }
    }

    console.error('[energyService] resposta inesperada:', status, response.url)
  } catch (e) {
    console.error('[energyService] erro ao buscar operadoras:', e)
  }

  return { success: false, payload: { operators: [] }, error: 'UnhandledError' }
}

const energyService = { getAll }
export default energyService
